var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a6 6 0 0 1 6-6h32a6 6 0 0 1 6 6v19.429a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V18Z",
    fill: "url(#visa-a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.172 26.014c-.017 1.314 1.17 2.047 2.064 2.482.92.448 1.228.734 1.224 1.134-.007.612-.733.882-1.412.893-1.185.018-1.875-.32-2.422-.576l-.428 1.998c.55.253 1.568.474 2.624.484 2.477 0 4.098-1.224 4.107-3.12.01-2.407-3.329-2.54-3.306-3.616.008-.326.32-.674 1.001-.762.338-.045 1.27-.08 2.326.407l.415-1.933A6.324 6.324 0 0 0 32.157 23c-2.332 0-3.972 1.24-3.985 3.014Zm10.178-2.847c-.453 0-.834.263-1.004.669l-3.54 8.45h2.477l.492-1.361h3.026l.286 1.362h2.182l-1.904-9.12H38.35Zm.346 2.463.715 3.425h-1.957l1.242-3.425ZM25.17 23.167l-1.952 9.12h2.36l1.95-9.12H25.17Zm-3.49 0-2.456 6.207-.994-5.278c-.116-.59-.577-.93-1.088-.93h-4.014l-.057.265c.825.18 1.76.468 2.328.776.347.189.447.354.56.802l1.882 7.278h2.493l3.823-9.12h-2.478Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa-a",
    x1: 25.766,
    y1: 43.429,
    x2: 35.923,
    y2: 13.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.8bb59b02.svg";
export { ForwardRef as ReactComponent };